import {useRef,useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';

const SalesOrderDetailEmailLog=({parentId,application,userData,parent,pageTabCallback,refreshToken})=>{
    const list_name='email_log';
    const executeQuery=useRef(true);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'EmailLog'}
                entityParams={['table_name=sales_order','record_id='+parentId,'_lang='+application.globalData.lang]}
                list_name={list_name}
                file={'SalesOrderDetailEmailLog.js'}
                navigateOnNew={null}
                initialState={{}}
                checkboxSelection={false}
                disableRowSelectionOnClick={true}
                disableSelectionOnClick={true}
                refreshToken={refreshToken}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,application.globalData.dataGridParams[list_name],refreshToken]);

    return(renderListTab);
}
export default SalesOrderDetailEmailLog;
